import { render, staticRenderFns } from "./courseKtcx.vue?vue&type=template&id=f1937896&scoped=true&"
import script from "./courseKtcx.vue?vue&type=script&lang=js&"
export * from "./courseKtcx.vue?vue&type=script&lang=js&"
import style0 from "./courseKtcx.vue?vue&type=style&index=0&id=f1937896&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1937896",
  null
  
)

export default component.exports